import { render, staticRenderFns } from "./leftNavbar.vue?vue&type=template&id=ff28a53e&scoped=true&"
import script from "./leftNavbar.vue?vue&type=script&lang=js&"
export * from "./leftNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff28a53e",
  null
  
)

export default component.exports